// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyButton_container__2M94X","title":"CopyButton_title__15YiM"};